import { styled, TableCell } from '@/core/ui';
import { shouldNotForwardProps } from '@/shared/helpers';
export const LoadingTableCell = styled(TableCell, shouldNotForwardProps('width', 'fitCell'))(({ width, fitCell }) => ({
    textAlign: 'center',
    ...(!fitCell && {
        padding: '100px',
    }),
    ...(width && {
        width,
    }),
}));
export const SpinnerContainer = styled('div', shouldNotForwardProps('height'))(({ theme, height }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(3),
    ...(height && {
        height,
    }),
}));
